<template>
  <div class="list">
    <div style="margin-bottom: 10px; cursor: pointer" v-show="multipleSelection.length">
      <el-tag
        closable
        :disable-transitions="false"
        @close="clearSelection"
        @click="selectApplyFor"
      >
        合并申请
      </el-tag>
    </div>
    <el-table
      row-class-name="defTableRowStyle"
      header-row-class-name="defTableHeaderStyle"
      :data="list"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      row-key="tradeNo"
      ref="tableRef"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column label="交易内容" show-overflow-tooltip prop="subject">
        <template slot-scope="scope">
          <span>{{ scope.row.subject }}</span>
        </template>
      </el-table-column>
      <el-table-column label="订单时间" show-overflow-tooltip prop="createdAt">
        <template slot-scope="scope">
          <span>{{ scope.row.createdAt | timeFormat("yyyy-mm-dd hh:MM") }}</span>
        </template>
      </el-table-column>
      <el-table-column label="可开金额" show-overflow-tooltip prop="paymentAmount">
        <template slot-scope="scope">
          <p v-if="scope.row.paymentAmount">
            ¥ {{ scope.row.paymentAmount | priceFormat }}
          </p>
          <p v-else>--</p>
        </template>
      </el-table-column>
      <el-table-column label="状态" show-overflow-tooltip prop="invoiced">
        <template slot-scope="scope">
          <span style="color: #f77234" v-if="scope.row.invoiced">开票中</span>
          <span v-else>未开票</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="120">
        <template slot-scope="{ row }">
          <div style="font-size: 14px; color: #0062ff" v-if="!row.invoiced">
            <span @click="applyFor(row)" class="pointer">申请发票</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <div class="pagination_left"></div>
      <el-pagination
        :current-page="parm.current"
        :page-sizes="[30, 40, 50, 60]"
        :page-size.sync="parm.size"
        popper-class="paginationTopStyle"
        background
        layout="total,  prev, pager, next"
        :total="parm.total"
        @size-change="sizeChange"
        @current-change="currentChange"
        :popper-options="{
          placement: 'top',
          boundariesPadding: 10,
        }"
      >
      </el-pagination>
    </div>
    <applyForForm ref="applyForFormRef" @success="getList" />
  </div>
</template>

<script>
import getList from "@/mixins/getList";
import applyForForm from "../components/form";
const listParams = {};
export default {
  mixins: [getList],
  components: { applyForForm },
  data() {
    return {
      list: [],
      listParams: {
        ...listParams,
      },
      multipleSelection: [],
    };
  },
  mounted() {
    // this.getList();
  },
  created() {},
  computed: {},
  methods: {
    clearSelection() {
      this.$refs.tableRef.clearSelection();
    },
    listApi(parm) {
      let data = { ...parm, ...this.listParams };
      return this.$api.getTradeInvoiceList(data);
    },
    // 申请发票
    applyFor(item) {
      const { tradeNo } = item;
      this.$refs.applyForFormRef.onShow([tradeNo]);
    },
    selectApplyFor() {
      // console.log(this.multipleSelection);
      this.$refs.applyForFormRef.onShow(this.multipleSelection.map((res) => res.tradeNo));
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
};
</script>

<style scoped lang="scss">
.list {
  padding: 0 16px;
  .pagination {
    display: flex;
    height: 60px;
    align-items: center;
    justify-content: space-between;
    .all {
      font-size: 14px;
      color: #666666;
      transition: all 0.3s;
      cursor: pointer;
      &:hover {
        color: #0062ff;
      }
    }
  }
}
</style>
